/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsFinding } from './JumboStructsFinding';
import {
    JumboStructsFindingFromJSON,
    JumboStructsFindingFromJSONTyped,
    JumboStructsFindingToJSON,
} from './JumboStructsFinding';

/**
 * 
 * @export
 * @interface JumboGetfindingsGetFindingsResult
 */
export interface JumboGetfindingsGetFindingsResult {
    /**
     * 
     * @type {Array<JumboStructsFinding>}
     * @memberof JumboGetfindingsGetFindingsResult
     */
    items?: Array<JumboStructsFinding>;
}

/**
 * Check if a given object implements the JumboGetfindingsGetFindingsResult interface.
 */
export function instanceOfJumboGetfindingsGetFindingsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetfindingsGetFindingsResultFromJSON(json: any): JumboGetfindingsGetFindingsResult {
    return JumboGetfindingsGetFindingsResultFromJSONTyped(json, false);
}

export function JumboGetfindingsGetFindingsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetfindingsGetFindingsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(JumboStructsFindingFromJSON)),
    };
}

export function JumboGetfindingsGetFindingsResultToJSON(value?: JumboGetfindingsGetFindingsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(JumboStructsFindingToJSON)),
    };
}

